// extracted by css-extract-rspack-plugin
export default {"radio":"Radio-module__radio--ve4y4","input":"Radio-module__input--OXeZz"};